import { colors, fontSizes } from 'ui/theme';
import { HistogramValue } from 'modules/iterableGoals/types';
import {
  CHART_X_AXIS_TITLE_MARGIN,
  CHART_Y_AXIS_TITLE_OFFSET,
  CHART_AXIS_TITLE_SIZE,
  chartAxisLabelBaseStyles,
} from '../constants/common';
import { currencyLabelFormatter, pointFormatter } from './common';

const dateTimeLabelFormats = {
  minute: '%l:%M%P',
  hour: '%l:%M%P', // 1:05pm
  day: '%b %e', // June 6
};

export const getHighchartOptions = (
  data: HistogramValue,
  getTranslation: (key: string, options?: Record<string, any>) => string,
  getReportingTranslation: (key: string) => string,
  isRevenue: boolean,
): Record<string, any> => {
  return {
    chart: {
      height: 415,
      type: 'line',
    },
    title: {
      text: undefined,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats,
      lineColor: colors.grey15,
      title: {
        text: getTranslation('labels.goalPerformance.xAxis'),
        margin: CHART_X_AXIS_TITLE_MARGIN,
        style: {
          fontSize: CHART_AXIS_TITLE_SIZE,
        },
      },
      labels: {
        style: {
          ...chartAxisLabelBaseStyles,
        },
      },
    },
    yAxis: {
      lineWidth: 1,
      lineColor: colors.grey15,
      gridLineColor: colors.grey15,
      gridLineDashStyle: 'ShortDash',
      max: Math.max(...(data?.buckets.map(({ value }) => value) || []), 0),
      endOnTick: true,
      title: {
        text: getReportingTranslation('labels.goalPerformance.yAxis'),
        offset: CHART_Y_AXIS_TITLE_OFFSET,
        style: {
          fontSize: CHART_AXIS_TITLE_SIZE,
        },
      },
      labels: {
        enabled: true,
        formatter: isRevenue ? currencyLabelFormatter : undefined,
        style: {
          ...chartAxisLabelBaseStyles,
        },
      },
    },
    plotOptions: {
      line: {
        states: {
          inactive: {
            enabled: false,
          },
        },
      },
    },
    tooltip: {
      shared: true,
      backgroundColor: colors.grey80,
      borderColor: colors.grey80,
      borderRadius: 8,
      borderWidth: 0,
      shadow: {
        opacity: 0.04,
        width: 1,
      },
      style: {
        color: colors.white,
        fontSize: fontSizes.s12,
      },
      headerFormat: `<span style="font-size: ${fontSizes.s12}">{point.key}</span><br/>`,
      pointFormatter: pointFormatter(isRevenue),
      dateTimeLabelFormats,
    },
    series: [
      {
        color: colors.purple100,
        name: getReportingTranslation('labels.goalPerformance.goalCompletions'),
        visible: true,
        data: data?.buckets.map(({ time, value }) => [time, value]) || [],
        marker: {
          symbol: 'circle',
          enabled: true,
        },
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxHeight: 400,
          },
        },
      ],
    },
  };
};
